import React from 'react';

import BreadcrumbList, { PathItem } from 'Components/SeoSchema/BreadcrumbList';
import config from 'config/config';
import { getL2Emoji } from 'pages/L4Category/BreadcrumbSchema';
import routes from 'utils/routeTranslator';

type L2Category = {
  slug: string;
  name: string;
};

type City = {
  slug: string;
  name: string;
  nameLocativeCase: string;
};

type BreadcrumbSchema$Props = {
  l2: L2Category;
  city?: City;
};

const BreadcrumbSchema = ({ l2, city }: BreadcrumbSchema$Props) => {
  const items: PathItem[] = [
    {
      name: config.SITE_NAME,
      url: config.SITE_URL,
    },
    {
      name: l2.name,
      url: `${config.SITE_URL}${routes.get('front::categories.type', { slug: l2.slug })}`,
    },
  ];

  if (city) {
    const cityName = `${l2.name} ${city.nameLocativeCase || city.name}`;
    const route = routes.get('front::categories.type', {
      slug: l2.slug,
      city: city.slug,
    });

    items.push({
      name: cityName,
      url: `${config.SITE_URL}${route}`,
    });
  }

  const lastItem = items[items.length - 1];
  lastItem.name = `${getL2Emoji(l2.slug)} ${lastItem.name}`;

  return <BreadcrumbList items={items} />;
};

export default BreadcrumbSchema;
